// extracted by mini-css-extract-plugin
module.exports = {"clickable":"CountDown_clickable__2oHry","count__down":"CountDown_count__down__eF8wM"};